import React, { useState } from 'react';
import MessageModal from './MessageModal';
import SuccessModal from './SuccessModal';
import { useMunicipalityTasks } from '../MunicipalityTasksContext';
import { ButtonStyle, InnerPlate, TextPlate, TitlePlate, WrapPlate } from './styled';
import { Space } from '@gr-monorepo/common/ui';
import { useClickStreamContext } from 'features/shared/ClickStream';
import { ReactComponent as PrizeIcon } from '../images/prize.svg';

const MessagePlate = ({
  messageTextToCopy,
  status,
  textPlate,
  titlePlate,
  titleModal,
  nameButton,
  number,
  taskName,
  children,
}: {
  messageTextToCopy: string;
  status: boolean;
  textPlate: JSX.Element;
  titlePlate: string;
  titleModal: string;
  nameButton: string;
  number: string;
  taskName: string;
  children: React.ReactNode;
}) => {
  const {updateMunicipalityTask, addModal, currentModal, closeModal } = useMunicipalityTasks();
  const [showModal, setShowModal] = useState(false);
  const [messageCopied, setMessageCopied] = useState(false);
  const { logPageEvent } = useClickStreamContext();

  const handleClick = () => {
    setShowModal(true);
    logPageEvent?.({
      eventType: `municipality_tasks`,
      eventInfo: `Клик по кнопке: ${nameButton} в плашке`,
    });
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(messageTextToCopy).then(() => {
      addModal(taskName);
      setShowModal(false);
      setMessageCopied(true);
      if (!status) updateMunicipalityTask(taskName);
      logPageEvent?.({
        eventType: `municipality_tasks`,
        eventInfo: `Клик по кнопке: Cкопировать в модальном окне`,
      });
    });
  };
  
  const handleCloseModal = () => {
    setMessageCopied(false);
    closeModal();
  };

  return (
    <>
      <WrapPlate>
      <InnerPlate>
        <PrizeIcon />
        <Space size={32} axis="vertical" />
        <TextPlate>{textPlate}</TextPlate>
      </InnerPlate>
      <Space size={40} axis="vertical" />
      <ButtonStyle color={'purple'} onClick={handleClick}>
        {nameButton}
      </ButtonStyle>
    </WrapPlate>
      {showModal || currentModal === taskName ? (
        !messageCopied ? (
          <MessageModal
            handleCopyClick={handleCopyClick}
            handleClose={() => setShowModal(false)}
            title={titleModal}
          >
            {children}
          </MessageModal>
        ) : (
          <SuccessModal onClose={handleCloseModal}>
            <p>Сообщение скопировано!</p>
            <p>
              Отправьте его школам по электронной почте <br /> или в мессенджере.
            </p>
          </SuccessModal>
        )
      ) : null}
    </>
  );
};
export default MessagePlate;
